import React from 'react'
import { changeTabIndex } from '../../redux/actions/action'
import { connect } from 'react-redux'
import {Button, Radio } from "antd";
import {DatePicker, List, Picker, Toast} from "antd-mobile";
import {API} from "../../configs/api.config";
import {fetchGet, fetchPost} from "../../utils/fetchRequest";

class ServiceExplain extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            id: this.props.match.params.id,
            appId: this.props.match.params.appId,
            openId: this.props.match.params.openId,
            isClickable: true,
            checked:false
        };
    }

    render () {
        const {
            isClickable, checked, appId
        } = this.state;
        return (

        <div className="common-column-layout" ref={node => this.node = node} onChange={this.handelValueCom} style={{fontFamily:"PingFangSC-Regular",letterSpacing:2.5}}>
        <div className="padding_15">
            <div className="color_red span_18 text_bold">用户协议</div>
            <div>&nbsp;&nbsp;&nbsp;&nbsp;
            本用户协议（简称"协议"）系由您与物联网云平台系统，您在注册及使用曲靖电信智慧电子学生证公众号（简称"公众号"）之前请认真阅读本协议，您点击"新用户办理"按纽或登录公众号后，证明您是自愿购买电子学生证及后续使用套餐服务本协议即构成对双方均具有约束力的法律文件。
            <div>一、隐私声明</div>
            <div>1/适用范围</div>
            <div>1.您注册公众号时，根据公众号要求提供的个人身份识别信息;</div>
            <div>2.在您使用公众号服务时，中国电信教育系统平台自动接收并记录的服务器数据。包括但不限于IP地址、在线、无线信息、 Cookie中的信息及您调用的记录数据;</div>
            <div>3.中国电信通过合法途径从商业伙伴处取得的用户个人资料。</div>
            <div>2/信息使用</div>
            <div>1.中国电信不会向任何个体或企业法人出售或出借您的个人信息，除非事先得到您的许可;</div>
            <div>2.为提供更好的使用体验以及服务用户目的，中国电信可能通过使用您的个人信息向您提供服务，包括但不限于向您发出活动和服务信息等;</div>
            <div>3/信息披露</div>
            <div>1.您的个人信息将在下述情况下部分或全部被披露。</div>
            <div>2.经您许可、向第三方披露;</div>
            <div>3.根据法律的有关规定或者应行政、司法机构的要求向第三方或行政、司法机构披露;</div>
            <div>4.如果您有违反中国有关法律法规需要向第三方披露时:</div>
            <div>5.为根据您所要求的产品或服务而必须与第三方分享您的个人信息时;</div>
            <div>4/信息授权</div>
            <div>1.本人授权中国电信除法律另有规定之外，将本人提供给公众号及关联系统的信息、公众号为您提供服务后产生的信息（包括本协议签署之前提供和服务产生的信息）以及中国电信根据本条约定查询、收集的信息或开展市场调查、数据分析得到的信息用于中国电信及其关联单位或因某项服务所必要的第三方合作伙伴;</div>
            <div>2.本人授权中国电信除法律另有规定之外，基于为本人提供更优质的服务与产品的日的，向中国电信因服务开展合作的伙伴提供、查询、收集本人的信息;</div>
            <div>3.为保障本人信息的安全，中国电信及其合作伙伴对上述信息具有保密义务，并段</div>
            <div>采取各项措施保证信息安全:</div>
            <div>4本条款具有独立法律效力，不受协议成立与否及效力状态变化的影响;</div>
            <div>二、服务条款的确认</div>
            <div>1、公众号的各项电子服务的所有权与运营权归中国电信所有。用户同意所有协议条款才能使用公众号。您同意:本协议条款是处理双方权利义务的有效约定，始终有效:</div>
            <div>2、用户点击注册开通或登录公众号的，即视为用户确认自己具有认同公众号服务、支付因服务所需的运营商话费流量的权利能力和行为能力，能够独立承担法律责任;</div>
            <div>3、如您未满18周岁，请在法定监护人的监护参与下使用公众号;</div>
            <div>4、中国电信拥有在中华人民共和国法律允许的范围内，独自决定拒绝服务、关闭用户账号、清除、编辑内容或取消用户向运营商已发生的缴费订单的权利;</div>
            <div>三、客户端服务</div>
            <div>2公众号的服务是按现有技术条件所能达到的现状提供的。中国电信会尽最大的努力为您提供服务、确保服务的连续性和安全性;但中国电信不能随时预见和防范相关法律、技术改变以及其它风险，包括但不限于不可抗力、病毒、木马、黑客攻击、系统不稳定、第三方服务BUG或瑕疵、政府行为等原因可能导致的服务中断、数据丢失以及其它的损失和风险。中国电信有义务在技术上确保各项服务的正常运行，尽力避免服务中断或将中断时间限制在最短时间内，保证用户服务活动的顺利进行。但无法保障因不可力或其他无法控制的原因使服务无法正常使用或服务无法完成或丢失有关的信息、记录等;任何用户向中国电信提供错误、不完整、不实信息等造成不能正常使用青苗服务或遭受任何其他损失，由用户自行承担责任。</div>
            <div>四、用户须知</div>
            <div>1、您在公众号内使用的用户名、昵称及上传的头像应符合网络道德并遵守中华人民共和国的相关法律法规;</div>
            <div>2、用户名、昵称及上传的头像中不能含有威胁、淫秽、漫骂、非法、侵害他人权益等有争议性的文字或图片;</div>
            <div>3、用户必须保护好自己的账号及密码、因用户本人泄露而造成的任何损失由用户本人负责，与中国电信无关;</div>
            <div>4、用户不得盗用他人的账号和密码使用，此行为将被依法追究法律责任;</div>
            <div>5、对于用户在公众号服务中的不当行为或其它任何中国电信认为应当终止服务的情况，中国电信有权随时作出删除相关信息、终止服务等处理，而无须征得用户的同意。</div>
            <div>6、必须自行准备上网设备，包括并不限于智能手机计算机终端或者其它上网设备、路由器、调制解调器及其它必备的上网设备;</div>
            <div>7、关于设备所提供的主要服务为通讯功能，其它辅助功能仅供参考，辅助功能所产生的数据不作为法律义务的参考数据，相关功能和数据产生偏差时，不对具体事件的结果发生关联，不承担法律责任和赔偿责任。</div>
            <div>8、产品在使用过程中功能和数据产生如下偏差应视为正常</div>
            <div>8.1、 通讯过程中会发生信号中断和网络中断</div>
            <div>8.2、 定位功能因卫星信号中断而无法使用</div>
            <div>8.3、 定位时由于信号延迟等导致的位置偏离</div>
            <div>8.4、 提示信息的延迟推送</div>
            <div>8.5、 设备故障导致的部分功能无法使用和该部分相关数据的丢失。</div>
            <div>五、知识产权声明</div>
            <div>中国电信所提供的网络服务的相关著作权、专利权、商标、商业秘密及其它任何所有权或权利，均属中国电信所有。非经中国电信同意，任何人或用户均不得擅自、复制、拷贝、传输、改编、反编译，出售、转售或用于任何其他商业目的，否则应负所有法律责任。中国电信拥有向用户提供服务过程中所产生并储存于服务器中的任何数据信息的所有权。</div>
            <div>六、协议的变更</div>
            <div>根据中国法律法规变化及网络运营需要，中国电信有权对本协议条款进行不定时修改，修改后的协议在公众号上发布即视为生效并代替原来的协议。用户可随时在公众号上查询最新协议文本;用户有义务不时关注并阅读最新协议及公众号公告。如用户不同意更新后的用户协</div>
            <div>议，可以且应立即停止接受公众号提供的服务，如用户继续使用公众号提供的服务即视为同意更新后的协议。如果本协议中的任何一条被视为废止、无效或因任何原因导致不可执行，该条应视为可分的且并不影响任何其余条款的可效性和可执行性。</div>
            <div>七、法律管辖及适用</div>
            <div>本协议的订立、执行与解释以及争议的解决均应适用中华人民共和国之有效法律。如发生本协议与适用法律相抵触时，则这些条款将完全按照法律规定重新解释，而其它条款则依旧保持对用户的约束力。如缔约双方就本协议内容或执行发生任何争议，双方应友好协商解决;协商不成时，双方一致同意服从当地中国电信住所地法院管辖。</div>
            </div>

            <div></div>

            <div className="color_red span_18 text_bold">隐私政策</div>
            <div>生效时间:2021年3月15日</div>
            <div>&nbsp;&nbsp;&nbsp;&nbsp;
            本政策仅适用于中国电信公司（以下简称"我们"）向中国电信用户（以下简称"你"）提供的“公众号”软件系统（或）随附的相关服务。欢迎你使用本应用提供的定位服务!我们非常重视你的隐私保护和个人信息保护。本隐私政策适用干你通过任何方式使用本应用的各项服务。本应用主要提供两类功能:定位服务和设备管理。如不同意本政策的任何内容或者无法理解相关内容，请不要进行后续操作。开始使用本应用，即表示你已充分理解并同意本隐私政策的全部内容本隐私政策将帮助你了解以下内容:
            <div>1、我们收集哪些信息</div>
            <div>2、信息的存储</div>
            <div>3、信息安全</div>
            <div>4、我们如何使用信息</div>
            <div>5、对外提供</div>
            <div>6、你的权利</div>
            <div>7、未成年人保护</div>
            <div>8、变更</div>
            <div>本隐私政策具体内容如下:</div>
            <div>1.我们收集哪些信息</div>
            <div>在你使用本应用的过程中，会按照如下方式收集你在使用服务时主动提供或因为使用服务而产生的信息，用以向你提供服务:</div>
            <div>1.1当你使用公众号注册时，我们会收集你填写的手机号码。手机号码属于敏感信息，收集此类信息是为了满足相关法律法规的网络实名制要求。如果拒绝提供该信息，将无法登录应用及使用应用内的各项功能。</div>
            <div>1.2当你使用本应用时，为保障你正常使用我们的服务，根据相关法律法规的要求，以及改进和优化我们的服务体验及保障你的账号安全。</div>
            <div>1.3我们会在获得你的自主选择同意后，获得你的精准定位信息（GPS信息），目的是为了向你提供定位服务。该信息属干敏感信息，拒绝提供该信息会使你无法查看当前位信息，但不影响你正常使用其他功能。</div>
            <div>1.4当你使用定位服务时，我们会使用百度地图的定位功能，因为设备定位服务是本应用的基础功能。我们收到百度地图返回的位置信息后会及时显示在地图上，不会另做它用。</div>
            <div>1.5当你使用平台消息推送功能时，我们会使用第三方推送服务（公众号推送），目的是为了向你提供消息推送服务，让你更快接收设备告警消息。</div>
            <div>请你理解，我们向你提供的功能和服务是不断更新和发展的，如果某一功能或服务未在前述说明中日收集了你的信息，我们会通过页面提示、交互流程、网站公告等方式另行向你说明信息收集的内容、范围和目的。</div>
            <div>2.信息的存储</div>
            <div>我们严格遵守法律法规的规定及与用户的约定，将收集的信息用于以下用途。若我们超出以下用途使用您的信息，我们将再次向您进行说明，并征得您的同意。</div>
            <div>本应用所收集的用户个人信息，在互联网线路通过加密传输存放至我们的系统服务器，进行加密存储，我们的机房管理、服务器管理、网络管理以及本应用安全具有较高的安全水平。我们仅在本政策所述目的所必需期间和法律法规、监管规定的期间内保存你的信息。除非经你自主选择或遵从相关法律法规要求，我们不会对外提供上述信息，或者将其用干该功能以外的其他用途。</div>
            <div>2.1信息存储的地点</div>
            <div>我们会按照法律法规规定，将在中国境内收集和产生的个人信息存储于中国境内。</div>
            <div>2.2信息存储的期限</div>
            <div>一般而言，我们仅为实现目的所必需的时间保留你的个人信息。当我们的产品或服务发生停止运营的情形时，我们将以推送通知、公告等形式通知你，在合理的期限内删除你的个人信息或进行匿名化处理，并立即停止收集个人信息的活动。</div>
            <div>3.信息安全</div>
            <div>我们努力为用户的信息安全提供保障，以防止信息的丢失、不当使用、未经授权访问或披露。</div>
            <div>我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全。例如，我们会使用加密技术（例如SSL）、匿名化处理等手段来保护你的个人信息。我们通过不断提升的技术手段加强安装在你设备端的软件的安全能力，以防止你的个人信息泄露。例如，我们为了安全传输会在你设备本地完成部分信息加密的工作。</div>
            <div>我们建立专门的管理制度、流程和组织以保障信息的安全。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务。若发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大，并以推送通知、公告等形式告知你。</div>
            <div>4.第三方共享部分</div>
            <div>4.1公众号推送</div>
            <div>功能:用于实现消息推送（或其他推送）功能;</div>
            <div>收集个人信息的类型:设备信息、地理位置、网络信息:</div>
            <div>4.2友盟移动统计分析组件SDK</div>
            <div>信息获取:MAC地址、唯一设备识别码（IMEI AndroidID、IDFA、OPENUDID、GUID、SIM卡IMSI信息）、地理位置信息:使用目的:数据统计;</div>
            <div>隐私协议地址:https://www.umeng.com/policy</div>
            <div>4.3百度定位SDK</div>
            <div>信息获取:硬件型号、操作系统版本、设备配置、唯一设备标识符、网络设备硬件地址MAC、广告标识符IDFA信息、设备连接信息以及设备状态信息、网络身份标识信息、位置信息、行踪轨迹，当您授予设备权限时，我们会收集国际移动设备身份码IMEI</div>
            <div>使用目的:显示地图、位置定位隐私协议地址:</div>
            <div> https://map.baidu.com/zt/client/privacy/in</div>
            <div>5.我们如何使用信息</div>
            <div>为了确保服务的安全，帮助我们更好地了解我们应用程序的运行情况，我们可能记录相关信息，例如，你使用应用程序的频率、崩溃数据、总体使用情况、性能数据以及应用程序的来源。我们不会将我们存储在分析软件中的信息与你在应用程序中提供的任何个人身份信息相结合。如我们使用你的个人信息，超出了与收集时所声称的目的及具有直接或合理关联的范围，我们将在使用你的个人信息前，再次向你告知并征得你的明示同意。</div>
            <div>6.对外提供</div>
            <div>我们不会对外披露收集的个人信息，如必须披露时，我们会向你告知此次公开披露的目的、披露信息的类型及可能涉及的敏感信息，并征得你的明示同意。</div>
            <div>此外，根据相关法律法规及国家标准，以下情形中，我们可能会在没有事先征询你同意的情况下将你的信息对外披露:</div>
            <div>1）与国家安全、国防安全直接相关的;</div>
            <div>2）与公共安全、公共卫生、重大公共利益直接相关的:</div>
            <div>3）与犯罪侦查、起诉、审判和判决执行等直接相关的;</div>
            <div>4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的;</div>
            <div>5）个人信息主体自行向社会公众公开的个人信息;</div>
            <div>6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道;</div>
            <div>7）法律法规规定的其他情形。</div>
            <div>6.你的权利</div>
            <div>在你使用本应用期间，为了你可以更加便捷地访问、更正、删除你的个人信息，同时保障你撤回对个人信息使用的同意及注销账号的权利，我们在产品设计中为你提供了相应的操作设置。</div>
            <div>个人信息查询、更正、删除的操作路径为:【我的】-【个人资料】。</div>
            <div>7.未成年人保护</div>
            <div>我们非常重视对未成年人个人信息的保护。根据相关法律法规的规定，若你是14周岁以下的未成年人，在使用本应用前，应事先取得你的家长或法定监护人的书面同意。</div>
            <div>8.变更</div>
            <div>我们可能会适时对本政策进行修订。当政策的条款发生变更时，我们会在你登录及版本更新时以弹窗的形式向你展示变更后的指引。请你注意，只有在你点击弹窗中的同意按钮后，我们才会按照更新后的指引收集、使用、存储你的个人信息。</div>

        </div>

        </div>
                <div style={{textAlign: 'center',padding:'2px 15px 15px 15px'}}><Radio onChange={date => this.setState({checked: !checked})} >同意，协议已阅读</Radio></div>

                <Button className='commonButton' type='primary' disabled={!checked} style={{margin: '35px',borderRadius:30, textAlign: 'center'}}
                                                                                                         onClick={this.onSubmitClick}>同意</Button>
                {/*checked==true?
                     <Button className='commonButton' type='primary' style={{margin: '35px',borderRadius:30, textAlign: 'center'}}
                                onClick={this.onSubmitClick}>同意</Button>:''*/}

             </div>)
        }

     onSubmitClick = (event) => {
        const {id, appId, openId}=this.state
             this.props.history.push('/servicePayCost/'+id+'/'+ appId +'/'+ openId);
     }
    }


const mapStateToProps = state => ({
  tabIndex: state.appState.tabIndex,
  userOpenid: state.redUserInfo.userOpenid,
  userInfo: { ...state.redUserInfo },
})

const mapDispatchToProps = dispatch => ({
  changeTabIndex: (tabIndex) => {
    dispatch(changeTabIndex(tabIndex))
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ServiceExplain)

